export const FEATURES = {
    PERMISSIONS: isActivated('VITE_SHOW_PERMISSIONS'),
    SUPPLIER_PORTAL: isActivated('VITE_SHOW_SUPPLIER_PORTAL'),
    OFFER_TO_ORDER: isActivated('VITE_ENABLE_ORDER_FROM_OFFER'),
    ORDER_CONFIRMATION_STATUS: isActivated('VITE_SHOW_ORDER_CONFIRMATION_STATUS'),
    RENTAL_RETURN: isActivated('VITE_ENABLE_RENTAL_RETURN'),
    TRANSPORT_COST_V2: isActivated('VITE_ENABLE_NEW_TRANSPORT_COST_CALCULATION'), // deprecated, needs to be removed
    TRANSPORT_COST_DEBUG_INFORMATION: isActivated('VITE_ENABLE_TRANSPORT_COST_DEBUG'),
    PRODUCT_QUERY: isActivated('VITE_SHOW_PRODUCT_QUERY'), // deprecated, needs to be removed
    LANDING_PAGE: isActivated('VITE_ENABLE_LANDING_PAGE'),
    ENABLE_TEST_FEATURES: isActivated('VITE_ENABLE_TEST_FEATURES'),
    OIL_PRICE_DISCLAIMER: isActivated('VITE_ENABLE_OIL_PRICE_DISCLAIMER'),
};

function isActivated(featureName: string): boolean {
    return import.meta.env[featureName] === 'true';
}
